var map = {
	"./avatar.svg": 442,
	"./db-logos/Cassandra.png": 1724,
	"./db-logos/arangodb.png": 1725,
	"./db-logos/athena.png": 1726,
	"./db-logos/aws_es.png": 1727,
	"./db-logos/axibasetsd.png": 1728,
	"./db-logos/azure_kusto.png": 1729,
	"./db-logos/bigquery.png": 1730,
	"./db-logos/bigquery_gce.png": 1731,
	"./db-logos/clickhouse.png": 1732,
	"./db-logos/cloudwatch.png": 1733,
	"./db-logos/cloudwatch_insights.png": 1734,
	"./db-logos/cockroach.png": 1735,
	"./db-logos/corporate_memory.png": 1736,
	"./db-logos/couchbase.png": 1737,
	"./db-logos/csv.png": 1738,
	"./db-logos/databend.png": 1739,
	"./db-logos/databricks.png": 1740,
	"./db-logos/db2.png": 1741,
	"./db-logos/dgraph.png": 1742,
	"./db-logos/drill.png": 1743,
	"./db-logos/druid.png": 1744,
	"./db-logos/dynamodb_sql.png": 1745,
	"./db-logos/elasticsearch.png": 1746,
	"./db-logos/elasticsearch2.png": 1747,
	"./db-logos/elasticsearch2_OpenDistroSQLElasticSearch.png": 1748,
	"./db-logos/elasticsearch2_XPackSQLElasticSearch.png": 1749,
	"./db-logos/exasol.png": 1750,
	"./db-logos/excel.png": 1751,
	"./db-logos/firebolt.png": 1752,
	"./db-logos/google_analytics.png": 1753,
	"./db-logos/google_spreadsheets.png": 1754,
	"./db-logos/graphite.png": 1755,
	"./db-logos/hive.png": 1756,
	"./db-logos/hive_http.png": 1757,
	"./db-logos/impala.png": 1758,
	"./db-logos/influxdb.png": 1759,
	"./db-logos/jirajql.png": 1760,
	"./db-logos/json.png": 1761,
	"./db-logos/kibana.png": 1762,
	"./db-logos/kylin.png": 1763,
	"./db-logos/mapd.png": 1764,
	"./db-logos/memsql.png": 1765,
	"./db-logos/mongodb.png": 1766,
	"./db-logos/mssql.png": 1767,
	"./db-logos/mssql_odbc.png": 1768,
	"./db-logos/mysql.png": 1769,
	"./db-logos/nz.png": 1770,
	"./db-logos/oracle.png": 1771,
	"./db-logos/pg.png": 1772,
	"./db-logos/phoenix.png": 1773,
	"./db-logos/pinot.png": 1774,
	"./db-logos/presto.png": 1775,
	"./db-logos/prometheus.png": 1776,
	"./db-logos/python.png": 1777,
	"./db-logos/qubole.png": 1778,
	"./db-logos/rds_mysql.png": 1779,
	"./db-logos/redshift.png": 1780,
	"./db-logos/redshift_iam.png": 1781,
	"./db-logos/results.png": 1782,
	"./db-logos/rockset.png": 1783,
	"./db-logos/salesforce.png": 1784,
	"./db-logos/scylla.png": 1785,
	"./db-logos/snowflake.png": 1786,
	"./db-logos/sparql_endpoint.png": 1787,
	"./db-logos/sqlite.png": 1788,
	"./db-logos/treasuredata.png": 1789,
	"./db-logos/trino.png": 1790,
	"./db-logos/uptycs.png": 1791,
	"./db-logos/url.png": 1792,
	"./db-logos/vertica.png": 1793,
	"./db-logos/yandex_appmetrika.png": 1794,
	"./db-logos/yandex_metrika.png": 1795,
	"./destinations/chatwork.png": 1796,
	"./destinations/email.png": 1797,
	"./destinations/hangouts_chat.png": 1798,
	"./destinations/hipchat.png": 1799,
	"./destinations/mattermost.png": 1800,
	"./destinations/microsoft_teams_webhook.png": 1801,
	"./destinations/pagerduty.png": 1802,
	"./destinations/slack.png": 1803,
	"./destinations/webhook.png": 1804,
	"./favicon-16x16.png": 1805,
	"./favicon-32x32.png": 1806,
	"./favicon-96x96.png": 1807,
	"./fixtures/map-tile.png": 1808,
	"./google_logo.svg": 1809,
	"./illustrations/alert.svg": 1810,
	"./illustrations/dashboard.svg": 1811,
	"./illustrations/no-query-results.svg": 1812,
	"./illustrations/query.svg": 1813,
	"./logo.png": 1814,
	"./logo_white.png": 1815,
	"./redash_icon_small.png": 110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1723;